import http from 'config/http';

import { getApiUrl } from 'config/api-url';

export const getSearchResults = async <T = unknown>(searchParam: string, q: string) => {
    const { data } = await http.get(`${getApiUrl()}/search/${searchParam}`, {
        params: {
            q,
        },
    });

    return { data, q } as { data: T[]; q: string };
};
